import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Menubar from "../../../../../components/MenuBar/Menubar";
import styles from "./style.module.css";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DashboardNavbar from "../../../../../components/DashBoardNavbar";

function ApplicationDetails() {
  const { id } = useParams(); // Get the ID parameter from the URL
  console.log(id);
  const [application, setApplication] = useState(null); // State to store application data
  const [activeButton, setActiveButton] = useState("applicant"); // State to track active button
  useEffect(() => {
    const fetchApplicationDetails = async () => {
      try {
        const authToken = localStorage.getItem("authtoken");
        const requestOptions = {
          method: "GET",
          headers: {
            "auth-token": authToken,
            Authorization: "Bearer yourToken",
            "Content-Type": "application/json",
          },
        };
        const response = await fetch(
          `https://job-application-mindtech.onrender.com/api/contact-form/${id}`,
          requestOptions
        ); // Replace with your backend API URL
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setApplication(data);
        console.log(data);
        // Set the fetched application data to state
      } catch (error) {
        console.error("Error fetching application details:", error);
      }
    };

    fetchApplicationDetails();
  }, [id]); // Trigger the effect whenever the ID parameter changes

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  if (!application) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className={styles.record}>
        <Menubar />
        <div className={styles.applicationContainer}>
          <DashboardNavbar />

          <h1 className={styles.tag2}> Contact Details </h1>
          <h3 className={styles.tag1}>Dashboard / Contact</h3>
          <div className={styles.insideApplicationContainer}>
            {/* Display application details using application object */}
            <div className={styles.btns}>
              <div
                className={`${styles.btn} ${
                  activeButton === "applicant" && styles.active
                }`}
                onClick={() => handleButtonClick("applicant")}
              >
                Contact Details
              </div>
            </div>
            {/* Conditional rendering based on active button */}
            {activeButton === "applicant" && (
              <div className={styles.detailSection}>
                <div className={styles.detail1}>
                  <p>Contact Name</p>
                  <p className={styles.val2}>{application.data.fullName}</p>
                  <p className={styles.val1}>Email Address</p>
                  <p className={styles.val2}>{application.data.email}</p>
                  {/* <p className={styles.val1}>Phone no</p>
                  <p className={styles.val2}>{application.phone}</p> */}
                </div>
                <div className={styles.detail2}>
                  <p>Phone no</p>
                  <p className={styles.val2}>{application.data.phone}</p>
                  <p className={styles.val1}>Message </p>
                  <p className={styles.val2}>
                    {application.data.message} Lorem ipsum dolor sit, amet
                    consectetur adipisicing elit. Est, quidem. Assumenda,
                    architecto.
                  </p>
                  {/* <p className={styles.val1}>Introduction</p>
                  <p className={styles.val2}>{application.introduction} Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo tempore est eveniet.</p> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationDetails;
